import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

type RouteType = IRoutes.Endpoints.Expert.Talent.ProfileData.PostProfileData;
type Input = RouteType["body"];
type Output = RouteType["outputData"];
type URL = RouteType["url"];

export class UseCasePostTalentProfileData {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (data: Input) => {
    const url: URL = "/expert/talent/profile-data";

    const result = await this.repository.create<Input, Output>(url, data);

    return result;
  };
}
